import { useCallback, useState } from "react";

export type SnackbarResultData<T> = {
  data: T | undefined;
  loading: boolean;
  error: string | undefined;
};
export type SnackbarTuple<T> = [
  (params: RequestInit) => Promise<T | undefined>,
  SnackbarResultData<T>
];

export type UseFetchOpts<T> = {
  onFetchSuccess?: (v: T) => void;
};

export function useFetch<T>(url: string, opts?: UseFetchOpts<T>) {
  const [data, setData] = useState<T | undefined>(void 0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>(void 0);

  const invoke = useCallback(
    async (params: RequestInit) => {
      setData(void 0);
      setLoading(true);

      try {
        const response = await fetch(url, params);
        let json;
        if (response.ok) {
          json = await response.json();

          setData(json);
        }
        setLoading(false);

        if (opts?.onFetchSuccess) {
          opts.onFetchSuccess(json as T);
        }

        return json as T;
      } catch (e) {
        setLoading(false);
        setError(e as string);
      }
    },
    [opts, url]
  );

  return [invoke, { data, loading, error }] as SnackbarTuple<T>;
}
